import { defineComponent as a, openBlock as n, createBlock as o, unref as r, withCtx as i, createElementVNode as m } from "vue";
import f from "../SfIconBase/SfIconBase.vue.mjs";
import { SfIconSize as s } from "@storefront-ui/shared";
const l = /* @__PURE__ */ a({
  __name: "SfIconMenu",
  props: {
    size: {
      type: String,
      default: s.base
    }
  },
  setup(t) {
    return (p, e) => (n(), o(r(f), {
      size: t.size,
      viewBox: "0 0 24 24",
      "data-testid": "menu"
    }, {
      default: i(() => e[0] || (e[0] = [
        m("path", { d: "M4 18a1 1 0 1 1 0-2h16a1 1 0 1 1 0 2zm0-5a1 1 0 1 1 0-2h16a1 1 0 1 1 0 2zM3 7a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1" }, null, -1)
      ])),
      _: 1
    }, 8, ["size"]));
  }
});
export {
  l as default
};
